var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDocFinantial = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 67C52.0015 67 67 52.0015 67 33.5C67 14.9985 52.0015 0 33.5 0C14.9985 0 0 14.9985 0 33.5C0 52.0015 14.9985 67 33.5 67Z",
    fill: "#BCD9C9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 67,
    height: 67
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 67C52.0015 67 67 52.0015 67 33.5C67 14.9985 52.0015 0 33.5 0C14.9985 0 0 14.9985 0 33.5C0 52.0015 14.9985 67 33.5 67Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 15,
    width: 28,
    height: 38
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15H46V53H18V15Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3273 53H19.673C18.7489 53 18 51.362 18 49.3398V18.6602C18 16.6387 18.7489 15 19.673 15H44.3273C45.2511 15 46 16.6387 46 18.6602V49.3398C46 51.362 45.2511 53 44.3273 53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6789 53H23.3211C20.3824 53 18 50.4922 18 47.3982V20.6013C18 17.5078 20.3824 15 23.3211 15H39.6789C42.6176 15 45 17.5078 45 20.6013V47.3982C45 50.4922 42.6176 53 39.6789 53Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 20C17.75 17.1005 20.1005 14.75 23 14.75H43C45.8995 14.75 48.25 17.1005 48.25 20V48C48.25 50.8995 45.8995 53.25 43 53.25H23C20.1005 53.25 17.75 50.8995 17.75 48V20Z",
    stroke: "#727D79",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 40,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#727D79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 46,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#727D79"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 19,
    width: 9,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 19H31.5V35H23.5V19Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7315 23.5403C30.4949 23.4827 30.8582 22.5595 30.341 22.0207C30.2576 21.9342 30.1688 21.8505 30.0747 21.7708C29.6013 21.3745 29.0095 21.0918 28.3586 20.9228V19.9894C28.3586 19.4432 27.8947 19 27.323 19C26.7508 19 26.2874 19.4432 26.2874 19.9894V20.9228C25.7543 21.0918 25.2217 21.3179 24.7489 21.6572L24.6891 21.7143L24.6299 21.7708C23.9204 22.3921 23.5653 23.1842 23.5056 23.9757C23.4464 24.8802 23.8612 25.7842 24.6299 26.5197C25.3998 27.2541 26.2874 27.4803 27.0561 27.6504C27.5887 27.7629 28.1219 27.876 28.5953 28.2158C29.0095 28.4985 29.2462 28.9502 29.3054 29.459C29.364 29.9684 29.1273 30.4772 28.7137 30.8724C28.0627 31.3818 26.8792 31.3818 26.1099 30.8164C25.988 30.7231 25.8862 30.6202 25.8046 30.5083C25.5827 30.203 25.2246 30.0164 24.8394 30.0684L24.6631 30.0928C23.9902 30.1843 23.6044 30.9023 23.9529 31.4598C24.1547 31.7832 24.4198 32.0805 24.7489 32.3423C25.2217 32.6815 25.6957 32.9642 26.2874 33.0778V34.0106C26.2874 34.5568 26.7508 35 27.323 35C27.8947 35 28.3586 34.5568 28.3586 34.0106V33.1343C29.0095 33.0213 29.6599 32.6815 30.1931 32.2863L30.3108 32.1732C31.1393 31.3818 31.5541 30.3076 31.4943 29.2329C31.4352 28.1587 30.8434 27.1416 29.9558 26.5197C29.1273 25.8973 28.2994 25.7282 27.6479 25.6146C26.997 25.4456 26.6425 25.389 26.2874 25.0493C25.9324 24.71 25.7549 24.3714 25.7549 23.9757C25.7549 23.6359 25.9916 23.3532 26.1685 23.1842C26.8792 22.6188 28.0627 22.6748 28.7137 23.2401C28.7137 23.2401 29.0113 23.5946 29.7315 23.5403Z",
    fill: "#FF8400"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDocFinantial);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-doc-finantial.f6c06f33ab1ccadb9b5f57e2b3319cf7.svg";